import { Controller } from "@hotwired/stimulus";
import { animate, utils } from "animejs";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  static targets = ["ribbon", "loader"];

  start(url, colors) {
    this.element.style.display = "block";

    this.setColors(colors);

    animate(this.loaderTarget, {
      translateY: ["-100%", "0%"],
      opacity: [0, 1],
      duration: 400,
      ease: "outCirc",
    });

    animate(this.ribbonTargets, {
      translateX: ["-100%", "0%"],
      duration: 1000,
      delay: () => utils.random(200, 500),
      ease: "outCirc",
      onComplete: () => {
        Turbo.visit(url);
        document.addEventListener("turbo:load", this.stop.bind(this), {
          once: true,
        });
      },
    });
  }

  stop() {
    animate(this.loaderTarget, {
      translateY: ["0%", "100%"],
      opacity: [1, 0],
      duration: 400,
      ease: "outCirc",
    });

    animate(this.ribbonTargets, {
      translateX: ["0%", "100%"],
      duration: 1000,
      delay: () => utils.random(200, 500),
      ease: "outCirc",
      onComplete: () => {
        this.element.style.display = "none";
      },
    });
  }

  setColors(colors) {
    this.ribbonTargets.forEach((el) => {
      el.className = `transition-ribbon color-${colors[0]} background-${colors[0]}`;
    });

    const svgPaths = this.loaderTarget.querySelectorAll("path, circle");
    Array.prototype.forEach.call(svgPaths, (el) => {
      el.style.fill = window.config.colors[colors[1]];
    });
  }
}
